import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import Validator from "validatorjs";
import { request as xhr, queryString as qs } from "../utils/request";
import { AppContext } from "../utils/context";
import { appEnv, webUrl } from "../utils/constants";

import CheckoutSteps from "../components/CheckoutSteps";
import CheckoutTickets from "../components/CheckoutTickets";
import CheckoutSummary from "../components/CheckoutSummary";
import CheckoutPersonalInfo from "../components/CheckoutPersonalInfo";
import CheckoutVerify from "../components/CheckoutVerify";
import CheckoutThankYou from "../components/CheckoutThankYou";
import CheckoutError from "../components/CheckoutError";
import CheckoutEnvelope from "../components/CheckoutEnvelope";
import classnames from 'classnames';

class CheckoutFreeTicket extends Component {
  constructor(props, context) {
    super(props);
    this.state = {
      loading: true,
      activeIndex: 1,
      activeSteps: [1],
      cartTotal: 0,
      cart: [],
      envelope: 0,
      beneficiaryId: 0,
      event: context.event,
      eventSubscribe: false,
      tickets_error: false,
      envelope_error: false,
      personal_info_error: false,
      isProcessLoading: false,
      validation: new Validator({}, {}),
      error: {
        code: 0,
        message: "",
        action: "default"
      },
      payment: {
        payToken: '',
        recurring: 0
      },
      order: {
        id: 0,
        hash: "",
        orderstatus: 0
      },
      personal: {
        id: 0,
        first_name: "",
        last_name: "",
        title: "",
        email: "",
        email_confirmation: "",
        phone: "",
        phone_home: "",
        phone_work: "",
        address: "",
        suite: "",
        city: "",
        state: "",
        country: context.settings.country || "USA",
        zip_code: "",
        latitude: "",
        longitude: "",
        age_range: "0",
        subscribe: [
          // {
          //   text: context.language.en.checkout_subscribe_sms,
          //   value: "text",
          //   checked: +context.settings.checkout_subscribe_sms > 0 ? true : false
          // },
          {
            text: context.language.en.checkout_subscribe_email,
            value: "email",
            checked: +context.settings.checkout_subscribe_email > 0 ? true : false
          }
        ],
        agreement: [
          {
            text: context.language.en.checkout_agreement_age,
            value: "oldenough",
            checked: 0
          },
          {
            text: context.language.en.checkout_agreement_rules,
            value: "rules",
            checked: 0
          }
        ],
        saveInfo: [
          {
            text: "Save my personal information for my next visit",
            value: "saveinfo",
            checked: true
          }
        ]
      },
      invalidEmailError: null
    };
  }

  componentDidMount = () => {
    const { history } = this.props;
    const { state } = this.props.location;
    let queryString = qs.parse(this.props.location.search);

    if (history.location.pathname.indexOf("free-tickets/thank-you") > -1 && typeof (queryString.orderId) === "undefined") {
      history.push("/free-tickets/select-tickets");
    }

    this.setState(
      {
        order: {
          id: queryString.orderId ? queryString.orderId : 0,
          hash: queryString.hash ? queryString.hash : 0
        }
      },
      () => this.handleCallback()
    );
  };
  handleCallback = () => {
    const { history } = this.props;
    let queryString = qs.parse(this.props.location.search);
    if (history.location.pathname.indexOf("/thank-you") > -1 && typeof (queryString.orderId) !== "undefined" && typeof (queryString.hash) !== "undefined") {
      this.getOrder();
    } else {
      this.setup();
    }
  }

  componentWillUnmount = () => {
    const { cookies } = this.props;
    cookies.remove("order");
    cookies.remove("cart");
    cookies.remove("envelope");
  };

  geofenceError = () => {
    var error = { ...this.state.error };
    error.code = 2;
    error.message = "Geofence Error: Provided location out of geofence bounds";
    this.setState({ error });
  }

  checkMaxMind = () => {
    const script = document.createElement("script");
    script.src = "https://geoip-js.com/js/apis/geoip2/v2.1/geoip2.js";
    script.async = true;
    script.onload = () => {
      this.setState({
        loading: false
      });
      window.geoip2.city(this.mmSuccess, this.mmError);
    };
    document.body.appendChild(script);
  };

  getOrder() {
    const { order, event, loading } = this.state;
    if (!order) {
      let error = {
        code: 1,
        message: "You have already claimed your maximum free tickets for this event !!!"
      }
      this.setState({ error: error });
      return false;
    }
    if (+order.id > 0) {
      return xhr
        .get(`api:/web/order/${order.id}`, {})
        .catch(err => {
          var error = { ...this.state.error };
          error.code = 10;
          error.message = err.message;
          error.action = "return";
          this.setState({ error });
          return err;
        })
        .then(resp => {
          if (+resp.id > 0) {
            let prices = event.prices;
            let ticketData = resp.ticketdata;
            let orderData = resp.orderdata;
            let envelope = resp.envelope;
            let cart = [];
            Object.keys(ticketData).map((v, k) => {
              return cart.push({
                tickets: v,
                cost: 0,
                qty: ticketData[v] ? ticketData[v] : 0
              });
            });
            order['orderstatus'] = resp.orderstatus;
            this.setState({
              loading: false,
              order: order,
              personal: orderData,
              cart: cart,
              envelope: +envelope,
              cartTotal: resp.totalcost
            });
          }
          return resp;
        });
    }
  }

  ValidateLocationSingle = (geoData, position) => {
    let self = this;

    var latTolerance = 0.01;
    var longTolerance = 0.01;      
    
    // Check if within bounds and tolerance
    let isOutsideBounds = position.coords.latitude > geoData.border.n + latTolerance || 
        position.coords.latitude < geoData.border.s - latTolerance || 
        position.coords.longitude < geoData.border.w - longTolerance || 
        position.coords.longitude > geoData.border.e + longTolerance;
        
    if (isOutsideBounds) {
      this.geofenceError();
    }

    //If we reached here, they are within the bounds and within tolerance.  Align them to a resolution lookup to the geo data
    var xRes = (geoData.res - 1) / (geoData.border.e - geoData.border.w)
    var yRes = (geoData.res - 1) / (geoData.border.n - geoData.border.s)
    var xLookup = Math.floor((position.coords.longitude - geoData.border.w) * xRes)
    var yLookup = Math.floor((geoData.res - 1) - ((position.coords.latitude - geoData.border.s) * yRes))  //This one gets inverted to align with bitmap data

    //Because we allow for tolerance we need to ensure the numbers properly align to index space
    if (xLookup < 0) { xLookup = 0; }
    if (xLookup >= geoData.Res) { xLookup = geoData.res-1; }
    if (yLookup < 0) { yLookup = 0; }
    if (yLookup >= geoData.Res) { yLookup = geoData.res-1; }

    //Use the lookups to test the geo data if the location is within borders or not
    //The geo data is set as an array of hex data, each element in the array is a row in the map
    //Each row is a hex string representing the bits in that map

    var geoRowData = geoData.data[yLookup];
    
    if(geoData.compression == "True")
      geoRowData = self.DecompressRow(geoRowData);
    
    //There are 4 bits per character, find the character
    var geoElementIndex = Math.floor(xLookup / 4) 
    var geoElementBitMask = 1 << (xLookup - (geoElementIndex * 4))
    var geoElementCharacter = geoRowData.charAt(geoElementIndex)
    var geoHex =  parseInt(geoElementCharacter, 16);

    //Test if the bit mask is within the hex data, if so this location is on the map
    if ((geoElementBitMask & geoHex) == geoElementBitMask) {
        return true;
    }                  
    else {
        this.geofenceError();
    }
  }
  ValidateLocationArray = (geoData, position) => {
    let self = this;

    var latTolerance = 0.01;
    var longTolerance = 0.01;                  
    var geoDataLocal = geoData;
    var found = 0;
    
    for(var i=0; i < geoDataLocal.length && found == 0; i++) {
      
       if (position.coords.latitude < geoDataLocal[i].border.n + latTolerance && 
           position.coords.latitude > geoDataLocal[i].border.s - latTolerance && 
           position.coords.longitude > geoDataLocal[i].border.w - longTolerance && 
           position.coords.longitude < geoDataLocal[i].border.e + longTolerance) {
          found = 1;
      }
                          
      //this only means that the position was found within the bounding box for the province, 
      // there can be overlap between the province's bounding boxes so need to check further
      if(found == 1) {

        var foundBoundary = i ;//where we broke out

        //If we reached here, they are within a bounds and within tolerance.  Align them to a resolution lookup to the geo data
        var xRes = (geoDataLocal[foundBoundary].res - 1) / (geoDataLocal[foundBoundary].border.e - geoDataLocal[foundBoundary].border.w)
        var yRes = (geoDataLocal[foundBoundary].res - 1) / (geoDataLocal[foundBoundary].border.n - geoDataLocal[foundBoundary].border.s)
        var xLookup = Math.floor((position.coords.longitude - geoDataLocal[foundBoundary].border.w) * xRes)
        var yLookup = Math.floor((geoDataLocal[foundBoundary].res - 1) - ((position.coords.latitude - geoDataLocal[foundBoundary].border.s) * yRes))  //This one gets inverted to align with bitmap data

        //Because we allow for tolerance we need to ensure the numbers properly align to index space
        if (xLookup < 0) { xLookup = 0; }
        if (xLookup >= geoDataLocal[foundBoundary].Res) { xLookup = geoDataLocal[foundBoundary].res-1; }
        if (yLookup < 0) { yLookup = 0; }
        if (yLookup >= geoDataLocal[foundBoundary].Res) { yLookup = geoDataLocal[foundBoundary].res-1; }

        //Use the lookups to test the geo data if the location is within borders or not
        //The geo data is set as an array of hex data, each element in the array is a row in the map
        //Each row is a hex string representing the bits in that map                  

        var geoRowData = geoDataLocal[foundBoundary].data[yLookup];  
        
        if(geoDataLocal[foundBoundary].compression == "True")  
          geoRowData = self.DecompressRow(geoRowData);

        //There are 4 bits per character, find the character
        var geoElementIndex = Math.floor(xLookup / 4) 
        var geoElementBitMask = 1 << (xLookup - (geoElementIndex * 4))
        var geoElementCharacter = geoRowData.charAt(geoElementIndex)
        var geoHex =  parseInt(geoElementCharacter, 16);

        //Test if the bit mask is within the hex data, if so this location is on the map
        if ((geoElementBitMask & geoHex) == geoElementBitMask) {
          return true;
        } 
        else {
          //this was within the province's bounding box but not in the province
          found = 0;
        }
      }//if found
    }//loop
    
    if(found == 0) {
        this.geofenceError();                     
    }    
  }
  DecompressRow = (rowData) => {
    //&16-080ff01&42-0 - form of rowData
    
    var outputRow = "";                  
    
    for(var i = 0; i< rowData.length; i++)
    {
      var myChar = rowData[i];
                          
      if(myChar == "&")
      {     
        var startPos = i+1;                                            
        var endPos = rowData.indexOf("-", startPos);
        i = endPos +1;
        
        var numberOfRepeats = rowData.substring(startPos, endPos);        
        var repeatingChar = rowData[i];
                                                    
        //add the repeatingChar 
        for(var j = 0; j< parseInt(numberOfRepeats); j++){
          outputRow += repeatingChar;                        
        } 
      }
      else{
        outputRow += rowData[i];
      }
    }
    
    return outputRow;
  }

  setup = () => {
    let self = this;
    const { event } = this.state;
    const { settings } = this.context;
    const { cookies, history } = this.props;

    // redirect '/select-tickets' to homepage if event.shopify_enabled
    if (+event.shopify_enabled === 1 && this.props.location.pathname === "/free-tickets/select-tickets") {
      window.location.href = "/";
    }

    let promise = Promise.resolve(true);
    if (
      settings.bitmask_url !== "" ||
      settings.web_geofence_state !== "" ||
      settings.web_geofence_country !== ""
    ) {
      promise = self.getPosition();
    }

    promise.then(success => {
      if (success === true) {
        return self.getOrder();
      }
    })
      .then(resp => {
        if (resp.id) {
          if (resp.orderstatus === 1) {
            cookies.remove('order');
            history.replace();
            history.replace(`/free-tickets/thank-you?orderId=${resp.id}&hash=${resp.orderhash}`);
            return Promise.reject('Order has already processed');
          }
        }
        return true;
      })
      .catch(err => {
        return false;
      })
      .then(resp => {
        let prices = event.prices;
        let loadCart = [];
        const { state } = this.props.location;
        if (prices) {
          Object.keys(prices).map((v, k) => {
            return loadCart.push({
              tickets: v,
              cost: prices[v].price,
              qty: state ? (state.pricePointKey === k ? 1 : 0) : 0
            });
          });
        }
        let loadPersonal = { ...this.state.personal };
        if (appEnv === "development") {
          loadPersonal["first_name"] = "Matt";
          loadPersonal["last_name"] = "annis";
          loadPersonal["email"] = "mannis2025@gmail.com";
          loadPersonal["email_confirm"] = "mannis2025@gmail.com";
          loadPersonal["phone"] = "6138971491";
          loadPersonal["phone_home"] = "";
          loadPersonal["phone_work"] = "";
          loadPersonal["address"] = "250 The Esplanade";
          loadPersonal["suite"] = "206";
          loadPersonal["city"] = "Toronto";
          loadPersonal["state"] = "ON";
          loadPersonal["zip_code"] = "M5A 4J6";
        }

        const { cookies } = this.props;
        const personalInfo = cookies.get("personal");
        const cart = cookies.get("cart");
        const order = cookies.get("order");
        const envelope = cookies.get("envelope");
        if (personalInfo) {
          loadPersonal = personalInfo;
        }
        if (cart) {
          loadCart = cart;
        }
        let callback = this.calculate;
        this.setState(
          {
            loading: false,
            cart: loadCart,
            personal: loadPersonal,
            envelope: +envelope
          },
          callback
        );
      });
  };
  getPosition = async () => {
    let self = this;
    const { settings } = this.context;

    const geoData = await fetch(`${settings.bitmask_url}`, {}).then(response => response.text()).catch(err => {
      this.geofenceError();
    }).then(text => {
      let data = JSON.parse(text.replace("var geoData = ", '').replace(/[a-z]+:/gi, function (x) {
        return '"' + x.replace(":", "") + '":';
      }));
      return data;
    });

    return new Promise(function (resolve, reject) {
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        timeout: 5000
      });
    })
      .then(position => {
        if (position === "ignore") return "ignore";
        let personal = { ...self.state.personal };
        personal["latitude"] = position.coords.latitude;
        personal["longitude"] = position.coords.longitude;
        this.setState({ personal });
        return position.coords;
      })
      .catch(err => {
        if (settings.maxmind_enabled) {
          this.checkMaxMind();
          return "ignore";
        }

        let message = "";
        switch (err.code) {
          case err.PERMISSION_DENIED:
            message =
              "You must allow your browser to share your location to purchase tickets. Please enable location services for this browser and try again.";
            break;
          case err.POSITION_UNAVAILABLE:
            message = "Location information is unavailable. In order to purchase tickets your location must be able to be determined. Please enable location services for this browser and try again.";
            break;
          case err.TIMEOUT:
            message = "The request to get user location timed out. In order to purchase tickets your location must be able to be determined. Please enable location services for this browser and try again.";
            break;
          default:
            message =
              "An unknown error occurred while attempting to determine your location... In order to purchase tickets your location must be able to be determined. Please enable location services for this browser and try again.";
        }
        var error = { ...this.state.error };
        error.code = err.code;
        error.message = message;
        error.action = "default";
        this.setState({ error });
        return false;
      })
      .then(coords => {
        if (coords === false) {
          return false;
        }
        if (coords === "ignore") {
          return "ignore";
        }

        // let payload = {
        //   latitude: coords.latitude,
        //   longitude: coords.longitude
        // };
        // return xhr.post("api:/web/geofence", payload);

        let position = {
          coords: {
            latitude: coords.latitude,
            longitude: coords.longitude
          }
        };

        // Ensure in proper state to validate location
        let dataIsInvalid = position == null || geoData == null;
        if (dataIsInvalid) {
          this.geofenceError();
        }

        // Validate location
        if(geoData.constructor === Array){ 
          self.ValidateLocationArray(geoData, position);
        }
        else{                        
          self.ValidateLocationSingle(geoData, position);
        }
      })

      // .then(resp => {
      //   if (resp === "ignore") return true;
      //   if (resp.success && resp.success === true) {
      //     return resp.message;
      //   } else {
      //     var error = { ...this.state.error };
      //     error.code = 2;

      //     if (resp && resp.message) {
      //       error.message = resp.message;
      //     }

      //     this.setState({ error });
      //     return false;
      //   }
      // });
  };

  mmSuccess = position => {
    const { settings } = this.context;

    if ((settings.web_geofence_country != '' && settings.web_geofence_country.toLowerCase() != position.country.names.en.toLowerCase())
    || (settings.web_geofence_state != '' && settings.web_geofence_state.toLowerCase() != position.subdivisions['0'].names.en.toLowerCase())) {
      return this.mmError();
    }

    // Position verified
    return position;
  };

  mmError = error_message => {
    var error = { ...this.state.error };
    error.code = "-1";
    error.message = "An unknown error occurred while attempting to determine your location... In order to purchase tickets your location must be able to be determined. Please enable location services for this browser and try again.";
    error.action = "default";
    this.setState({ error });
    return false;
  };

  checkout = (recaptcha) => {
    let self = this;
    const { cookies } = this.props;
    const { event } = this.state;

    if (event.web_sales_paused) {
      let error = {
        "code": 1,
        "message": "Redemption is currently unavailable (web sales paused)"
      }
      self.setState({ error: error });
      cookies.remove('order');
      cookies.remove("cart");
      cookies.remove("envelope");
      return false;
    }

    this.saveCart();

    this.saveOrder()
      .then(function (resp) {
        self.setState({ order: resp.data }, () => self.processOrder(recaptcha))
        cookies.set('order', resp.data);
      })
  };
  processOrder = (recaptchaKey) => {
    let self = this;
    let recaptcha = recaptchaKey;
    const { cookies, history } = this.props;
    let fetchedOrder = self.getOrder();

    if (fetchedOrder) {
      fetchedOrder.then(resp => {
        if (resp.id && +resp.orderstatus === 0) {
          return xhr.post(`api:/web/free-order/${resp.id}/process`, { recaptcha: recaptcha }).then(resp => {
            if (resp.recaptchaError) {
              let error = {
                "code": 1,
                "message": "There was an error verifying reCaptcha, please try again."
              }
              self.setState({ error: error });
              cookies.remove('order');
              cookies.remove("cart");
              cookies.remove("envelope");
              return false;
            }
            return resp;
          });
        }
      })
        .then(resp => {
          if (!resp) {
            setTimeout(() => { self.getOrder().then(resp => {
              if (resp.id && (+resp.orderstatus === 0 || +resp.orderstatus === 1 || +resp.orderstatus === 2)) {
                history.replace();
                history.replace(`/free-tickets/thank-you?orderId=${resp.id}&hash=${resp.orderhash}`);
              } else {
                let error = {
                  "code": 0,
                  "message": "There was a problem processing your order"
                }
                this.setState({ error: error });
              }
              cookies.remove('order');
              cookies.remove("cart");
              cookies.remove("envelope");
            })}, 5000);
            return false;
          } else {
            cookies.remove('order');
            cookies.remove("cart");
            cookies.remove("envelope");
            history.replace();
            this.setState({ isProcessLoading: false }, () => history.replace(`/free-tickets/thank-you?orderId=${resp.id}&hash=${resp.orderhash}`));
          }
        });
    } else {
      let error = {
        "code": 1,
        "message": "You have already claimed your maximum free tickets for this event !!!"
      }
      this.setState({ error: error });
    }
  };

  saveCart = () => {
    const { cookies } = this.props;

    const { personal, cart, order } = this.state;
    if (personal.saveInfo[0].checked) cookies.set("personal", personal);
    cookies.set("order", order);
    // cookies.set("cart", cart);
    return true;
  };
  savePersonal = () => {
    this.saveCart();
    const { personal } = this.state;
    let payload = personal;

    return xhr.post("api:/web/save-personal", payload).then(resp => {
      let personal = { ...this.state.personal };
      personal["id"] = resp.customer.id;
      this.setState({ personal });
      return resp;
    });
  };
  saveOrder = () => {
    this.saveCart();
    const { event, personal, order, cart, cartTotal, payment, envelope, beneficiaryId } = this.state;
    let payload = {
      eventId: event.id,
      personal: personal,
      order: order,
      cart: cart,
      total: cartTotal,
      payment: {},
      envelope: envelope,
      beneficiaryId: beneficiaryId
    };

    let result;
    if (order.id > 0) {
      result = xhr.put(`api:/web/order/${order.id}`, payload);
    } else {
      result = xhr.post("api:/web/free-order", payload)
    }

    return result;
  };
  handleEnvelope = e => {
    const { cookies } = this.props;
    cookies.set("envelope", e.currentTarget.getAttribute('data-index'));
    this.setState({ envelope: +e.currentTarget.getAttribute('data-index'), envelope_error: false });
  };
  handleBeneficiary = (e) => {
    const { value } = e;
    this.setState({ beneficiaryId: value });
  }
  handleChange = e => {
    let { name, value } = e.target;
    let personal = { ...this.state.personal };
    personal[name] = value;
    this.setState({ personal });
  };
  handlePhoneNumber = e => {
    let { name, value } = e.target;
    value = value.replace(/\D/g, "");
    let personal = { ...this.state.personal };
    personal[name] = value;
    this.setState({ personal });
  }
  handleSubscribe = e => {
    let { value, checked } = e.target;
    let personal = { ...this.state.personal };
    let subscribe = personal.subscribe;
    subscribe.forEach(sub => {
      if (sub.value === value) sub.checked = checked;
    });
    personal["subscribe"] = subscribe;
    this.setState({ personal });
  };
  handleAgreement = e => {
    let { value, checked } = e.target;
    let personal = { ...this.state.personal };
    let agreement = personal.agreement;
    agreement.forEach(agree => {
      if (agree.value === value) agree.checked = checked;
    });
    personal["agreement"] = agreement;
    this.setState({ personal });
  };
  handleEventSubscription = e => {
    let payment = { ...this.state.payment };
    payment.recurring = e.target.checked === true ? 1 : 0;
    this.setState({ payment });
  };
  handleSaveInfo = e => {
    let { value, checked } = e.target;
    let personal = { ...this.state.personal };
    let saveInfo = personal.saveInfo;
    saveInfo.forEach(info => {
      if (info.value === value) info.checked = checked;
    });
    personal["saveInfo"] = saveInfo;
    this.setState({ personal });
  };
  calculate = () => {
    let cart = this.state.cart;
    let total = 0;
    cart.map(c => {
      return (total += c.qty * c.cost);
    });
    this.setState({ cartTotal: total });
  };
  validateCart = () => {
    this.saveCart();
    const { event } = this.state;
    const { history } = this.props;
    event.game.id === 3 ? history.push("/free-tickets/pick-envelope") : history.push("/free-tickets/personal-info");
  };
  validateCartTickets = () => {
    this.saveCart();
    const { history } = this.props;
    history.push("/free-tickets/personal-info");
  };
  validateCartFinal = () => {
    this.saveCart();
    const { history } = this.props;
    const rules = {
      envelope: "min:1"
    };
    const customMessages = {
      "min.envelope": "Please pick an envelope to continue"
    };
    let validation = new Validator(this.state, rules, customMessages);

    if (validation.passes()) {
      history.push("/free-tickets/personal-info");
    } else {
      this.setState({ validation, envelope_error: true });
    }
  };
  emailValidation = (email) => {
    const regex = /^[-!#-'*+\/-9=?^-~]+(?:\.[-!#-'*+\/-9=?^-~]+)*@[-!#-'*+\/-9=?^-~]+(?:\.[-!#-'*+\/-9=?^-~]+)+$/i;
    if (regex.test(email)) {
      return true;
    }
    else {
      return false;
    }
  }
  validatePersonal = () => {
    this.saveCart();
    const { history } = this.props;
    const rules = {
      "first_name": "required|string",
      "last_name": "required|string",
      "email": "required|email|confirmed",
      "email_confirmation": "required|email",
      "phone": "required|digits:10",
      "address": "required|string",
      "city": "required|string",
      "country": "required|string",
      "state": "required|string",
      "zip_code": "required|string",
      "agreement.*.checked": "accepted"
    };
    const customMessages = {
      "accepted.agreement.0.checked": "I am at least 18 years of age field is required",
      "accepted.agreement.1.checked": "I have read and agreed to the rules, terms and privacy policy field is required",
    };
    let validation = new Validator(this.state.personal, rules, customMessages);
    if (validation.passes()) {
      if (this.emailValidation(this.state.personal.email)) {
        history.push("/free-tickets/confirm-order");
        this.setState({ personal_info_error: false, invalidEmailError: null });
      } else {
        this.setState({ personal_info_error: true, invalidEmailError: "The email format is invalid" });
      }
    }
    this.setState({ validation });
  };
  validateConfirm = (recaptcha) => {
    const { event } = this.state;
    this.setState({ isProcessLoading: true });
    this.saveCart();

    const rules = {};
    const rulesCta = {
      envelope: "min:1"
    };
    
    let validation = (event.game.id == 3) ? new Validator(this.state, rulesCta) : new Validator(this.state, rules);

    if (validation.passes()) {
      this.checkout(recaptcha);
    } else {
      this.setState({ validation, personal_info_error: true, isProcessLoading: false });
    }
  }

  goToPrevious = () => {
    const { event } = this.state;
    switch (this.props.location.pathname) {
      case "/free-tickets/thank-you":
        this.props.history.push("/free-tickets/confirm-order");
        break;
      case "/free-tickets/confirm-order":
        this.props.history.push("/free-tickets/personal-info");
        break;
      case "/free-tickets/personal-info":
        event.game.id === 3 ? this.props.history.push("/free-tickets/pick-envelope") : this.props.history.push("/free-tickets/select-tickets");
        break;
      case "/free-tickets/pick-envelope":
        this.props.history.push("/free-tickets/select-tickets");
        break;
    }
  };
  getEnvelopeHeight = (url) => {
    let image = new Image();
    image.src = url;
    let height = image.height > 640 ? 640 : image.height;
    return height;
  }

  render() {
    const {
      cart,
      cartTotal,
      error,
      event,
      order,
      personal,
      validation,
      envelope,
      payment,
      loading
    } = this.state;
    const { settings, language, config } = this.context;
    const { pathname: path } = this.props.location;
    let envelopeBackgroundImageHeight = this.getEnvelopeHeight(settings.envelope_background_image);

    const heroBoxClasnames = classnames('container', 'content', 'm-auto', { 'box-it': +settings.checkout_box_highlighting === 1 })

    let steps = [];
    this.context.event.game.id === 3 ? (config.allowFreeTicket ?
      steps = [
        {
          active: path === "/free-tickets/select-tickets" ? true : false,
          title: "Select Tickets"
        },
        {
          active: path === "/free-tickets/pick-envelope" ? true : false,
          title: "Pick Envelope"
        },
        {
          active: path === "/free-tickets/personal-info" ? true : false,
          title: "Personal Info"
        },
        {
          active: path === "/free-tickets/confirm-order" ? true : false,
          title: "Review Order"
        },
        {
          active: path === "/free-tickets/thank-you" ? true : false,
          title: "Print Tickets"
        }
      ]
      :
      steps = [
        {
          active: path === "/select-tickets" ? true : false,
          title: "Select Tickets"
        },
        {
          active: path === "/pick-envelope" ? true : false,
          title: "Pick Envelope"
        },
        {
          active: path === "/personal-info" ? true : false,
          title: "Personal Info"
        },
        {
          active: path === "/confirm-order" ? true : false,
          title: "Review Order"
        },
        {
          active: (path === "/payment-info" || path === "/process-order") ? true : false,
          title: "Payment Info"
        },
        {
          active: path === "/thank-you" ? true : false,
          title: "Print Tickets"
        }
      ])
      :
      steps = [
        {
          active: path === "/select-tickets" ? true : false,
          title: "Select Tickets"
        },
        {
          active: path === "/personal-info" ? true : false,
          title: "Personal Info"
        },
        {
          active: path === "/confirm-order" ? true : false,
          title: "Review Order"
        },
        {
          active: (path === "/payment-info" || path === "/process-order") ? true : false,
          title: "Payment Info"
        },
        {
          active: path === "/thank-you" ? true : false,
          title: "Print Tickets"
        }
      ];
    if (this.state.loading === true) return '';
    return (
      <div className=" mx-auto py-6 video-main video-bg" style={{ backgroundColor: settings.hero_background_color }}>
        <div className="video cover align-center align-middle">
          {settings.checkout_background_image && settings.checkout_background_image !== "" && (
            <img
              src={`${settings.checkout_background_image}`}
              alt=""
              className="opacity-75"
            />)
          }
        </div>
        <div className={heroBoxClasnames}>
          <h1 className="mb-6">Checkout</h1>
          {error.code > 0 || error.message !== "" ? (
            <CheckoutError error={error} order={order} event={event} language={language} />
          ) : (
            <div>
              <CheckoutSteps steps={steps} />
              <CheckoutSummary
                freeTicket={config.allowFreeTicket}
                event={this.context.event}
                envelope={envelope}
              />
              <Switch>
                <Route
                  path="/free-tickets/select-tickets"
                  exact
                  render={props => (
                    <CheckoutTickets
                      freeTicket={config.allowFreeTicket}
                      context={this.context}
                      handleBeneficiary={this.handleBeneficiary}
                      validateCart={this.validateCart}
                      validateCartTickets={this.validateCartTickets}
                      {...props}
                    />
                  )}
                />
                <Route
                  path="/free-tickets/pick-envelope"
                  exact
                  render={props => (
                    <CheckoutEnvelope
                      envelope={envelope}
                      envelopes={event.cards}
                      handleEnvelope={this.handleEnvelope}
                      validateCartFinal={this.validateCartFinal}
                      goToPrevious={this.goToPrevious}
                      envelope_error={this.state.envelope_error}
                      valid={validation.errorCount > 0 ? validation.errors.errors : {}}
                      scripts_pick_envelope={settings.scripts_pick_envelope}
                      envelope_number_color={settings.envelope_number_color}
                      envelope_background_image={settings.envelope_background_image}
                      envelopeBackgroundImageHeight={envelopeBackgroundImageHeight < +settings.envelope_background_default_height ? +settings.envelope_background_default_height : envelopeBackgroundImageHeight}
                    />
                  )}
                />
                <Route
                  path="/free-tickets/personal-info"
                  exact
                  render={props => (
                    <CheckoutPersonalInfo
                      freeTicket={config.allowFreeTicket}
                      data={personal}
                      valid={
                        validation.errorCount > 0 ? validation.errors.errors : {}
                      }
                      settings={this.context.settings}
                      handleChange={this.handleChange}
                      handlePhoneNumber={this.handlePhoneNumber}
                      handleSubscribe={this.handleSubscribe}
                      handleAgreement={this.handleAgreement}
                      handleEventSubscription={this.handleEventSubscription}
                      handleSaveInfo={this.handleSaveInfo}
                      validatePersonal={this.validatePersonal}
                      event={this.context.event}
                      goToPrevious={this.goToPrevious}
                      defaultCountry={this.context.settings.country}
                      invalidEmailError={this.state.invalidEmailError}
                      config = {config}
                      {...props}
                    />
                  )}
                />
                <Route
                  path="/free-tickets/confirm-order"
                  exact
                  render={props => <CheckoutVerify
                    freeTicket={config.allowFreeTicket}
                    recaptchaKey={this.context.config.google_recaptcha_public_key}
                    recaptchaType={this.context.config.option_recaptcha_type}
                    settings={this.context.settings}
                    data={personal}
                    validateConfirm={this.validateConfirm}
                    isProcessLoading={this.state.isProcessLoading}
                    event={this.context.event}
                    personal_info_error={this.state.personal_info_error}
                    goToPrevious={this.goToPrevious}
                    {...props} />}
                />
                <Route
                  path="/free-tickets/thank-you"
                  exact
                  render={props => (
                    <CheckoutThankYou
                      order={order}
                      event={event}
                      personal={personal}
                      {...props}
                      settings={this.context.settings}
                      loading={loading}
                    />
                  )}
                />
              </Switch>
            </div>
          )}
        </div>
      </div>
    );
  }
}
CheckoutFreeTicket.contextType = AppContext;

export default CheckoutFreeTicket;